<app-hero image="hero/hero_home.png" title="Maëlyse & Aurélien">
             <span class="fs30">{{joursRestants}}</span>   
</app-hero>
<div class="container-fluid no-margin">
    <div class="row">
        <div class="col-12 offset-lg-3 col-lg-6 text row">
            <div class="col-12 italic text-terra fs40">
                Nous nous marions (enfin) !
            </div>
            <div class="col-12">
                <img class="separator" src="spot-separator.png" alt="separator" width="70">
            </div>
            <div class="col-12 fs30 italic">
                Le 21&nbsp;.&nbsp;08&nbsp;.&nbsp;2027
                <br />
                Au Château de Granoupiac
                <br />
                34750 Saint André de Sangonis
            </div>
            <div class="col-12">
                <img class="separator" src="spot-separator.png" alt="separator" width="70">
            </div>
            <div class="col-12 fs20">
                Rejoignez nous pour une journée inoubliable sur le thème de la Dolce Vita Méditerranéenne
            </div>
            <div class="col-12">
                <img class="separator" src="spot-separator.png" alt="separator" width="70">
            </div>
        </div>
    </div>
</div>